import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import styles from './ErrorBoundary.module.css';

export function ErrorBoundary() {
  const error = useRouteError();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred. Please try again or return to the admin dashboard.';

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page not found';
      message = "The page you're looking for doesn't exist or has been moved.";
    } else {
      title = `${error.status} ${error.statusText || 'Error'}`;
      message = error.data?.message || message;
    }
  }

  return (
    <div className={styles.container}>
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.text}>{message}</p>
      <a href="/" className={styles.link}>
        ← Return to Admin Dashboard
      </a>
    </div>
  );
}
